export const messages = {
    campaign: {
        title: 'Enter a campaign title',
        campaignType: 'Select campaign Duration type whether its for short period or an ongoing event',
        status: 'Select campaign status. Is the campaign still running?',
        startDate: 'Select campaign start date',
        endDate: 'Select campaign end date',
        cta: 'Specify using text what should be done once a user clicks on the campaign',
        landingPageURL: 'Enter a link/url to campaign details page where user is redirected after clicking on campaign ',
        patientFacingEmail: 'Enter email id for Patient Communication, All the communication with the patients will be done using this email id',
        thumbnailImageURL: 'Enter URL/Upload image for campaign thumbnail image. Image dimensions should be 286px by 283px. Size of image should not exceed  1MB',
        heroImageURL: 'Enter URL/Upload image for Campaign Hero image. Image dimensions should be 720px by 400px. Size of image should not exceed 1MB',
        shortDescription: 'Enter Campaign description in brief i.e. What is the campaign about, for whom ,Duration  and benefits',
        longDescription: 'Describe campaign in detail like eligibility rules. terms and conditions etc',
        practiceLogoURL: 'Enter URL/Upload image for Practice Logo image. Image dimensions should be 286px by 283px. Size of image should not exceed 1MB'
    },
    offer: {
        title: 'Enter the offer title',
        triggerType: 'Select when is the offer applicable the trigger type for the offer',
        triggerValue: 'Enter a trigger value ',
        rewardType: 'Select reward type',
        rewardValue: 'Enter Text to shown once the user gets reward',
        status: 'Select offer status .Is the offer still running',
        frequency: 'Repeat the offer.  How frequently this offer is run,',
        actionText: 'Offer action text',
        actionURL: 'Offer action URL',
        expiryDate: 'Offer lasts till date. Specify expiry date of the offer',
        shortDescription: 'Offer description in brief (Teaser)like Discount, freebies and last date',
        longDescription: 'Offer description in detail like eligibility ,rules  How to avail the offer ,Terms and conditions etc.',
        offerImageURL: 'Enter URL/Upload image for Offer image. Image dimensions should be 720px by 400px. Size of image should not exceed 1MB',
    },
    drawing:{
        title: 'Add a title for the drawing',
        numberOfWinners: 'Enter maximum number of winners',
        status: 'Enter Drawing status',
        drawingType: 'Select drawing type',
        runDate: 'Enter a drawing run date',
        detailedDescription: 'Enter drawing description in detail Drawing amount/tickets Drawing rules, Eligibility criteria ,Terms and Conditions etc.',
        thumbnailImageURL: 'Enter URL/Upload image for Drawing thumbnail image. Image dimensions should be 286px by 283px. Size of image should not exceed  1MB',
        heroImageURL: 'Enter URL/Upload image for Drawing Hero image. Image dimensions should be 720px by 400px. Size of image should not exceed 1MB',
    },
    drawingRules:{
        title: 'Enter Rule title',
        status: 'Select Drawing rule status',
        rewardType: 'Select a reward type to be issued in the drawing',
        rewardValue: 'Specify the Reward value corresponding to the reward type for the current drawing',
        numberOfTicketsGranted: 'Enter total number of tickets to be granted under one drawing',
        maxNumberOfTickets: 'Maximum number of tickets to be issued for this drawing'
    },
    dashboard:{
        forward: 'Move patient to different queue',
        remove: 'Remove patient',
        queue: 'Time in queue',
        dashboard: 'Time in dashboard',
        score: 'Score',
        label: 'Add/Remove lable to the card'
    }
}